import {
  boardRequestOptions,
  shortlistBoardPath,
  type ShortlistBoardHttpConfig
} from '../shortlist-board/shortlistBoard.api.http';
import type {
  FeedbackTarget,
  ShortlistFeedbackApi
} from './shortlistFeedback.api';

/** A guest names themselves in the body; a member is the session's, and sends none. */
export function createShortlistFeedbackApi(
  config: ShortlistBoardHttpConfig
): ShortlistFeedbackApi {
  async function post(
    target: FeedbackTarget,
    action: 'vote' | 'unvote' | 'comment',
    body: { value?: string }
  ) {
    const { board, blockId, author } = target;
    await config.client.post(
      `${shortlistBoardPath(board.publicId)}/feedback/${action}`,
      {
        ...boardRequestOptions(config, board.password),
        params: { view: board.view },
        data: {
          block_id: blockId,
          ...body,
          ...(author.type === 'guest' && {
            guest: { id: author.id, name: author.name }
          })
        }
      }
    );
  }

  return {
    vote: (target, vote) =>
      vote === null
        ? post(target, 'unvote', {})
        : post(target, 'vote', {
            value: vote === 'up' ? 'UPVOTE' : 'DOWNVOTE'
          }),
    comment: (target, text) => post(target, 'comment', { value: text })
  };
}
